import { render, staticRenderFns } from "./politicalEnvironment.vue?vue&type=template&id=0d106afc&scoped=true"
import script from "./politicalEnvironment.vue?vue&type=script&lang=js"
export * from "./politicalEnvironment.vue?vue&type=script&lang=js"
import style0 from "./politicalEnvironment.vue?vue&type=style&index=0&id=0d106afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d106afc",
  null
  
)

export default component.exports